<template>
<table class="table is-fullwidth answer-options-table">
    <thead>
        <tr>
            <th class="is-1 has-text-centered">
                <span>#</span>
            </th>
            <th :class="{'is-8': !isFullScreenTest, 'is-9': isFullScreenTest}">
                <span>
                    {{ trans.edit_form.question_tabs.question_answers_text_label}}
                </span>
            </th>
            <th :class="{'is-2': !isFullScreenTest, 'is-1': isFullScreenTest}">
                <!-- TODO: добавить локализацию с описанием того как работают баллы -->
                <abbr v-if="question.settings.is_has_points" :title="trans.edit_form.question_tabs.question_answers_points_label">
                    {{ trans.edit_form.question_tabs.question_answers_points_label}}
                </abbr>

                <abbr v-else :title="trans.edit_form.question_tabs.question_answers_checkbox_label">
                    {{ trans.edit_form.question_tabs.question_answers_checkbox_label }}
                </abbr>
            </th>
            <th class="is-1"></th>
        </tr>
    </thead>
    <tbody>
        <question-edit-answer-option-table-row
            v-for="(answer, id) in question.answers"
            :key="id"
            :answer="answer"
            :answer-id="id"
            :row-number="getRowNumber(id)"
            :question-id="question.hash_id"
            :is-has-points="!!question.settings.is_has_points"
            :disabled="disabled"
        />
    </tbody>
</table>
</template>

<script>
import {mapGetters} from "vuex";
import QuestionEditAnswerOptionTableRow from "./QuestionEditAnswerOptionTableRow";

export default {
    name: "QuestionEditAnswerOptionsTable",
    components: {QuestionEditAnswerOptionTableRow},
    props: {
        question: Object,
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapGetters('tests',[
            'trans',
            'isFullScreenTest',
        ]),
    },
    methods: {
        getRowNumber(answerId) {
            let keys = Object.keys(this.question.answers);

            return keys.indexOf(answerId) + 1;
        }
    }
}
</script>

<style lang="scss">
@import 'resources/sass/variables';

.bulma {
    .table.answer-options-table {
        background: transparent;
        border-collapse:separate;
        border-spacing:0 10px;
        margin-bottom: 0;
        table-layout:fixed;

        th, td {
            border: none;
            vertical-align: middle;
        }

        thead th {
            padding-top: 0;
            padding-bottom: 0;
        }

        tbody tr {
            background: $white;
            height: 55px;

            td {
                &:first-child {
                    border-radius: 6px 0 0 6px;
                }

                &:last-child {
                    border-radius: 0 6px 6px 0;
                }
            }
        }
    }
}
</style>